.EcoSuiteNavbarAvatar {
  --size: 28px;

  width: var(--size);
  height: var(--size);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: var(--pdt-radius-full);
  background-color: var(--pdt-color-bg-brand);
  color: var(--pdt-color-text-on-bold);
  font-size: var(--pdt-text-body-sm-font-size);
  text-transform: uppercase;
  font-weight: var(--pdt-font-weight-regular);

  &--button {
    background-color: var(--avatar-bg);
    color: var(--avatar-color);
  }
}
